/**
 * Map FE cookie language → portal locale tag for X-Portal-Locale.
 * tw→zh-TW, zh→zh-CN, en, ja
 */
export function frontendLangToPortalLocale (lang) {
  const t = String(lang || '').trim().toLowerCase()
  if (!t || t === 'tw') return 'zh-TW'
  if (t === 'zh') return 'zh-CN'
  if (t === 'en') return 'en'
  if (t === 'ja') return 'ja'
  if (t === 'zh-tw' || t === 'zh-hant') return 'zh-TW'
  if (t === 'zh-cn' || t === 'zh-hans') return 'zh-CN'
  return 'zh-TW'
}

export function getPortalLocaleFromCookie (Cookies, getLanguage) {
  let lang = null
  try {
    if (Cookies && typeof Cookies.get === 'function') {
      lang = Cookies.get('language')
    }
  } catch (e) { /* ignore */ }
  if (!lang && typeof getLanguage === 'function') {
    try { lang = getLanguage() } catch (e2) { /* ignore */ }
  }
  return frontendLangToPortalLocale(lang)
}

/**
 * Pick name from nameI18n object / JSON string for a portal locale tag.
 */
export function pickNameI18n (nameI18n, portalLocale) {
  if (!nameI18n) return ''
  let obj = nameI18n
  if (typeof nameI18n === 'string') {
    const s = nameI18n.trim()
    if (!s) return ''
    try {
      obj = JSON.parse(s)
    } catch (e) {
      return ''
    }
  }
  if (!obj || typeof obj !== 'object') return ''
  const tag = frontendLangToPortalLocale(portalLocale)
  const hit = obj[tag] || obj[tag.replace('-', '_')]
  if (hit != null && String(hit).trim()) return String(hit).trim()
  if (tag === 'zh-TW' && obj['zh-CN']) return String(obj['zh-CN']).trim()
  if (tag === 'zh-CN' && obj['zh-TW']) return String(obj['zh-TW']).trim()
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/portalLocale.js